import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as $f8mV7$useState, useCallback as $f8mV7$useCallback } from "react";
import { useId as $f8mV7$useId, mergeProps as $f8mV7$mergeProps } from "@react-aria/utils";
import { privateValidationStateProp as $f8mV7$privateValidationStateProp } from "@react-stately/form";
import { useFocusWithin as $f8mV7$useFocusWithin, useScrollWheel as $f8mV7$useScrollWheel } from "@react-aria/interactions";
import { useFormattedTextField as $f8mV7$useFormattedTextField } from "@react-aria/textfield";
import { useSpinButton as $f8mV7$useSpinButton } from "@react-aria/spinbutton";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $f6896b05b2ecad12$export$77e32ca575a28fdf(props, state, ref) {
  var isDisabled = props.isDisabled,
    isReadOnly = props.isReadOnly,
    isRequired = props.isRequired,
    isWheelDisabled = props.isWheelDisabled,
    _props$validationBeha = props.validationBehavior,
    validationBehavior = _props$validationBeha === void 0 ? 'aria' : _props$validationBeha;
  var colorValue = state.colorValue,
    inputValue = state.inputValue,
    increment = state.increment,
    decrement = state.decrement,
    incrementToMax = state.incrementToMax,
    decrementToMin = state.decrementToMin,
    commit = state.commit;
  var inputId = (0, $f8mV7$useId)();
  var _ref = (0, $f8mV7$useSpinButton)({
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      isRequired: isRequired,
      maxValue: 0xFFFFFF,
      minValue: 0,
      onIncrement: increment,
      onIncrementToMax: incrementToMax,
      onDecrement: decrement,
      onDecrementToMin: decrementToMin,
      value: colorValue ? colorValue.toHexInt() : undefined,
      textValue: colorValue ? colorValue.toString('hex') : undefined
    }),
    spinButtonProps = _ref.spinButtonProps;
  var _ref2 = (0, $f8mV7$useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    focusWithin = _ref3[0],
    setFocusWithin = _ref3[1];
  var _ref4 = (0, $f8mV7$useFocusWithin)({
      isDisabled: isDisabled,
      onFocusWithinChange: setFocusWithin
    }),
    focusWithinProps = _ref4.focusWithinProps;
  var onWheel = (0, $f8mV7$useCallback)(function (e) {
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    if (e.deltaY > 0) increment();else if (e.deltaY < 0) decrement();
  }, [decrement, increment]);
  // If the input isn't supposed to receive input, disable scrolling.
  var scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
  (0, $f8mV7$useScrollWheel)({
    onScroll: onWheel,
    isDisabled: scrollingDisabled
  }, ref);
  var onChange = function onChange(value) {
    if (state.validate(value)) state.setInputValue(value);
  };
  var _ref5 = (0, $f8mV7$useFormattedTextField)(_objectSpread({}, props, _defineProperty(_defineProperty(_defineProperty(_defineProperty({
      id: inputId,
      value: inputValue,
      defaultValue: undefined,
      validate: undefined
    }, (0, $f8mV7$privateValidationStateProp), state), "type", 'text'), "autoComplete", 'off'), "onChange", onChange)), state, ref),
    inputProps = _ref5.inputProps,
    otherProps = _objectWithoutProperties(_ref5, ["inputProps"]);
  inputProps = (0, $f8mV7$mergeProps)(inputProps, spinButtonProps, focusWithinProps, {
    role: 'textbox',
    'aria-valuemax': null,
    'aria-valuemin': null,
    'aria-valuenow': null,
    'aria-valuetext': null,
    autoCorrect: 'off',
    spellCheck: 'false',
    onBlur: commit
  });
  if (validationBehavior === 'native') inputProps['aria-required'] = undefined;
  return _objectSpread({
    inputProps: inputProps
  }, otherProps);
}
export { $f6896b05b2ecad12$export$77e32ca575a28fdf as useColorField };